const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-utils",
    meta: {},
    name: "m-utils",
    component: () => import("@/modules/mutils/RootView")
});

export default Routes;